export const TITLE_SUFFIX = ' | dinlab · 发现你的设计创造力'
export const DINLAB_WEBSITE = 'https://www.dinlab.cn/'
